import {CBTextBox} from "../../../components/common/ContentBox";
import {enrollFactor, activateTotp} from "../../../services/api/factorApi";
import {runApi} from "../../../services/api/ApiContext";
import {useState} from "react";
import {toast} from "react-toastify";
import GAIcon from "../../../../images/icon_GA.png";
import IconUser from "../../../../images/icon_user.png"
import {AuthBox, AuthContent, AuthIcon, AuthButton, AuthBack, AuthQr, AuthIntro} from "../../common/AuthBox";
import {useHistory} from "react-router-dom";
import {useFactors} from "../../../contexts/FactorsContext";

const playStoreGoogleAuthLink = process.env.REACT_APP_GOOGLE_AUTH_PLAY_STORE;
const appStoreGoogleAuthLink = process.env.REACT_APP_GOOGLE_AUTH_APP_STORE;

const OktaEnrollGoogleAuth = () => {

    const [enrollStep, setEnrollStep] = useState(1);
    const [passCode, setPassCode] = useState(null);
    const [qrCodeLink, setQrCodeLink] = useState(null);
    const [factorId, setFactorId] = useState(null);
    const [selectedDevice, setSelectedDevice] = useState(null);
    const [barCodePage, setBarCodePage] = useState(true);
    const [sharedSecret, setsharedSecret] = useState(null);
    const history = useHistory();
    const {refresh} = useFactors();
    const enroll = async () => {
        setEnrollStep(3);
        const enrollGoogleAuthResponse = await runApi(
            'enrollGoogleAuth',
            () => enrollFactor("token:software:totp", "GOOGLE")
        );

        if (!enrollGoogleAuthResponse?.data?.status) {
            return;
        }

        setFactorId(enrollGoogleAuthResponse?.data?.data?.id);
        setsharedSecret(enrollGoogleAuthResponse?.data?.data?._embedded?.activation?.sharedSecret);
        setQrCodeLink(enrollGoogleAuthResponse?.data?.data?._embedded?.activation?._links?.qrcode?.href);
    }

    const toActivate = () => {
        setEnrollStep(4);
    }

    const toStep2 = () => {
        setEnrollStep(2);
    }

    const activate = async () => {
        const activateGoogleAuthResponse = await runApi(
            'enrollGoogleAuth',
            () => activateTotp(factorId, passCode)
        );

        if (!activateGoogleAuthResponse?.data?.status) {
            return;
        }

        toast.success("Activate OKTA verify successfully.")
        finishActivate();
    }

    const finishActivate = () => {
        refresh();
        history.push('/profile/mfa');
    }

    return (
        <AuthBox>
            <AuthIcon src={enrollStep === 1 ? IconUser : GAIcon}/>
            {enrollStep === 1 &&
            <AuthIntro Title={"Google Authenticator"} Description={"Enter single-use code from the mobile app."}
                       Icon={GAIcon} nextEvent={() => toStep2()}/>}
            {enrollStep === 2 &&
            <AuthContent>
                <p><strong>Setup Google Authenticator</strong></p>
                <form className="select-device">
                    <label>Select your device type</label>
                    <div><input type="radio" name="device-type"
                                onClick={() => setSelectedDevice("iPhone")}/> iPhone
                    </div>
                    <div><input type="radio" name="device-type"
                                onClick={() => setSelectedDevice("Android")}/> Android
                    </div>
                </form>
                {selectedDevice &&
                <div className="google-authenticator clearfix" style={{"border-top": "1px solid #eee"}}>
                    <img src={GAIcon} className="icon_GA" alt="GAIcon"/>
                    <div className="right">
                        {selectedDevice === "iPhone" &&
                        <p>Download <a href={appStoreGoogleAuthLink} rel="noreferrer" target="_blank" className="blue">Google Authenticator from the App
                            Store</a> onto
                            your
                            mobile device.</p>}
                        {selectedDevice === "Android" &&
                        <p>Download <a href={playStoreGoogleAuthLink} rel="noreferrer" target="_blank" className="blue">Google Authenticator from the
                            Google Play Store</a> onto
                            your
                            mobile device.</p>}
                    </div>
                </div>}
                {selectedDevice && <AuthButton buttonEvent={() => enroll()} buttonText={"Next"}/>}
                <AuthBack src="/profile/mfa/enroll/GOOGLE/token:software:totp"/>

            </AuthContent>}
            {enrollStep === 3 && <AuthContent>
                <p><strong>Setup Google Authenticator</strong></p>
                <AuthQr style={{display: (barCodePage ? 'block' : 'none')}}
                        displayText={'Launch Google Authenticator, tap the "+" icon, then select "Scan barcode".'}
                        src={qrCodeLink} noBarCodeEvent={() => setBarCodePage(false)}/>
                <div style={{display: (barCodePage ? 'none' : 'block')}}><p>Can't scan barcode?</p>
                    <p>To set up manually enter your Account username and then input the following in the Secret Key
                        Field
                    </p>
                    <form className="enter-code">
                        <CBTextBox disabled value={sharedSecret}></CBTextBox>
                    </form>
                </div>
                <AuthButton buttonEvent={() => toActivate()} buttonText={"Next"}/>
                <AuthBack src="/profile/mfa/enroll/GOOGLE/token:software:totp"/>

                <span style={{float: 'right', display: (barCodePage ? 'none' : 'block'), cursor: 'pointer'}} className="link-back"
                      onClick={() => setBarCodePage(true)}>Scan barcode</span>
            </AuthContent>}
            {enrollStep === 4 && <AuthContent>
                <p><strong>Set up multifactor authentication</strong></p>
                <p>Enter Code displayed from the application</p>
                <form className="enter-code">
                    <label>Enter Code</label>
                    <CBTextBox disabled={false} value={passCode}
                               onChange={e => setPassCode(e.target.value)}></CBTextBox>
                </form>

                <AuthButton buttonEvent={() => activate()} buttonText={"Verify"}/>
                <AuthBack src="/profile/mfa/enroll/GOOGLE/token:software:totp"/>
            </AuthContent>}
        </AuthBox>
    );
};

export default OktaEnrollGoogleAuth;
